import { RolesDashboardType } from '@api-client-retail/model/rolesView';
import { RouteInfo } from './vertical-menu.metadata';

//Sidebar menu Routes and data
export const ROUTES: RouteInfo[] = [
  // {
  //   path: '/dashboard', title: 'Dashboard', icon: 'icon-pie-chart', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
  // },
   {
    path: '/maps', title: 'NAVBAR.MENU_ITEMS.MAP', icon: 'icon-map', class: '', badge: '', badgeClass: '',
    isExternalLink: false,
    submenu: []
  },
  {
    path: '/dashboard', title: 'NAVBAR.MENU_ITEMS.DASHBOARDS', icon: 'icon-bar-chart', class: '', badge: '', badgeClass: '',
    isExternalLink: false,
    submenu: [
      {
        path: '/dashboard/roi',
        title: 'NAVBAR.SUB_MENU_ITEMS.ROI',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        roles: [ RolesDashboardType.roi]
      },
      {
        path: '/dashboard/poi',
        title: 'NAVBAR.SUB_MENU_ITEMS.POI',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        roles: [ RolesDashboardType.poi]
      },
      {
        path: '/dashboard/presence',
        title: 'NAVBAR.SUB_MENU_ITEMS.PRESENCE',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        roles: [RolesDashboardType.onlyPresence]
      },
      {
        path: '/dashboard/performance',
        title: 'NAVBAR.SUB_MENU_ITEMS.PERFORMANCE',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        roles: [RolesDashboardType.poi]
      },
      {
        path: '/dashboard/poa',
        title: 'NAVBAR.SUB_MENU_ITEMS.POA',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        roles: [RolesDashboardType.inOut, RolesDashboardType.inOutGender]
      },
      {
        path: '/dashboard/store-window',
        title: 'NAVBAR.SUB_MENU_ITEMS.STORE_WINDOW',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        roles: [RolesDashboardType.storeWindow]
      },
      {
        path: '/dashboard/store-front',
        title: 'NAVBAR.SUB_MENU_ITEMS.STORE_FRONT',
        icon: '',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        roles: [RolesDashboardType.storeFront]
      }]
  },
  {
    path: '/pages/users-list', title: 'NAVBAR.MENU_ITEMS.USERS', icon: 'icon-settings', class: '', badge: '', badgeClass: '',
    isExternalLink: false,
    isAdmin: true,
    submenu: []
  }
];
